import { render } from "./TransferDetailPoint.vue?vue&type=template&id=184343c8&scoped=true"
import script from "./TransferDetailPoint.vue?vue&type=script&lang=js"
export * from "./TransferDetailPoint.vue?vue&type=script&lang=js"

import "./TransferDetailPoint.vue?vue&type=style&index=0&id=184343c8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184343c8"]])

export default __exports__